import { Box, type SxProps, type Theme } from "@mui/system";
import type { FC } from "react";

export const TraineeIcon: FC<{ height?: number; width?: number }> = ({ height = 20, width = 20 }) => (
	<svg
		className="svg-icon"
		style={{ width, height, fill: "currentColor" }}
		viewBox={`${height} ${width} 1026 1024`}
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Trainee</title>
		<path
			d="M512.072321 64.049197L64.09528 238.44026 512.072321 412.831322l450.088933-174.391062L512.008325 64.049197z m23.03882-59.644943l450.152929 174.391063a63.99672 63.99672 0 0 1 0 119.353883L535.111141 472.540262a63.99672 63.99672 0 0 1-46.333626 0L40.864471 298.021206a63.99672 63.99672 0 0 1 0-119.289886l447.977041-174.391062a63.99672 63.99672 0 0 1 46.269629 0z"
			fill="#333333"
		/>
		<path
			d="M760.763576 663.890456h63.99672v73.724221c-106.106562 83.771707-212.533108 94.267169-319.343634 94.267169-106.874523 0-213.749045-10.495462-320.623568-94.267169V345.570769l63.996721 30.462439v329.071135c70.844369 47.741553 143.672637 62.716786 256.626847 62.716786 112.634227 0 185.142511-14.911236 255.346914-62.588792v-41.341881z m-255.346914 103.99467c112.634227 0 185.142511-14.975233 255.346914-62.652789v-41.341881h63.99672v73.724221c-106.106562 83.771707-212.533108 94.267169-319.343634 94.267169-106.874523 0-213.749045-10.495462-320.623568-94.267169V346.466724l63.996721 29.438491v329.199128c70.844369 47.741553 143.672637 62.716786 256.626847 62.716786zM532.999249 291.941518a31.99836 31.99836 0 0 1 22.142865-60.028924L832.055922 333.923366V455.709125a31.99836 31.99836 0 1 1-63.99672 0V378.52908L532.999249 291.877521z"
			fill="#333333"
		/>
		<path
			d="M792.441952 723.215415h15.23122l0.57597-4.351777a38.526026 38.526026 0 0 1-8.19158-5.759705 38.526026 38.526026 0 0 1-8.19158 5.759705l0.639967 4.351777z m-15.99918 233.396039h47.293577l-23.678787-176.630948-23.678786 176.630948z m-2.367878-297.392759h51.965336a25.598688 25.598688 0 0 1 25.406698 22.206862l41.533872 310.192103a25.598688 25.598688 0 0 1-25.406698 28.990514h-135.03308a25.598688 25.598688 0 0 1-25.406698-28.990514l41.597869-310.192103a25.598688 25.598688 0 0 1 25.342701-22.206862z"
			fill="#333333"
		/>
		<path
			d="M800.057562 694.608881c-58.237015 0-101.754785-56.317114-101.754785-122.361729s43.51777-122.361729 101.754785-122.361729 101.754785 56.317114 101.754785 122.361729-43.51777 122.361729-101.754785 122.361729z m0-63.99672c18.815036 0 37.758065-24.574741 37.758065-58.365009 0-33.726272-18.943029-58.365009-37.758065-58.365008s-37.758065 24.638737-37.758065 58.365008c0 33.790268 18.943029 58.365009 37.758065 58.365009z"
			fill="#333333"
		/>
	</svg>
);

export const StaffIcon: FC<{ height?: number; width?: number; fill?: string; sx?: SxProps<Theme> }> = ({
	height = 20,
	width = 20,
	fill = "var(--inhouse-primary)",
	sx,
}) => (
	<Box
		component="svg"
		viewBox="-5 -3 40 40"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		sx={[
			{
				width: width,
				height: height,
			},
			...(Array.isArray(sx) ? sx : [sx]),
		]}
	>
		<title>staff icon</title>
		<path d="M21.0508 17.6172L17.8614 16.0225C20.1148 14.1851 21.6574 10.9611 21.6574 8.06652C21.6574 3.76779 18.156 0.20874 13.8574 0.20874C9.55881 0.20874 6.05742 3.76779 6.05742 8.06652C6.05742 10.9611 7.60009 14.1851 9.85342 16.0225L6.66403 17.6172C3.44009 17.7558 0.857422 20.4079 0.857422 23.6665V28.9243C0.857422 29.4096 1.2387 29.791 1.72409 29.791H12.9908C12.9908 27.2772 12.9908 25.5461 12.9908 23.3372L13.8574 22.9039L14.7241 23.3372C14.7241 25.5342 14.7241 27.2835 14.7241 29.791H25.9908C26.4761 29.791 26.8574 29.4096 26.8574 28.9243V23.6665C26.8574 20.4079 24.2748 17.7558 21.0508 17.6172ZM10.6854 22.5572L8.18936 18.7959L10.0961 17.8426L12.5921 21.6039L10.6854 22.5572ZM13.8574 20.3731L11.5868 16.9759C12.0323 16.4406 12.0376 15.5427 11.0921 14.805C9.40622 13.4898 8.13199 11.1447 7.84281 8.93318H12.1241C13.5454 8.93318 14.7934 8.25718 15.5908 7.19985C16.3881 8.25718 17.6361 8.92741 19.0574 8.92741H19.872C19.5774 11.1807 18.26 13.5785 16.5267 14.8785C15.5993 15.5407 15.5015 16.3416 16.0414 17.0971L13.8574 20.3731ZM15.1228 21.6038L17.6188 17.8425L19.5255 18.7959L17.0295 22.5571L15.1228 21.6038ZM22.5241 26.2665H19.0574C18.5784 26.2665 18.1908 25.8789 18.1908 25.3999C18.1908 24.9208 18.5784 24.5332 19.0574 24.5332H22.5241C23.0031 24.5332 23.3908 24.9208 23.3908 25.3999C23.3908 25.8789 23.0031 26.2665 22.5241 26.2665Z" />
	</Box>
);
